// AI generated

import { useDebouncedCallback } from '@mantine/hooks'
import { useEffect, useRef } from 'react'
import { Transforms } from 'slate'
import { ReactEditor, useSlate } from 'slate-react'
import type { FlowElement } from '..'
import { DEFAULT_FLOW_HEIGHT, HEIGHT_SAVE_DEBOUNCE_MS } from '../constants'

/** Returns the ref to put on the resizable container. */
export function useFlowHeight(element: FlowElement) {
  const editor = useSlate()
  const containerRef = useRef<HTMLDivElement>(null)
  const lastHeightRef = useRef<number>(element.height || DEFAULT_FLOW_HEIGHT)

  const saveHeightInSlate = useDebouncedCallback((height: number) => {
    const path = ReactEditor.findPath(editor, element)
    if (!path) return

    Transforms.setNodes(editor, { height }, { at: path })
  }, HEIGHT_SAVE_DEBOUNCE_MS)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // round to nearest 10px
        const newHeight = Math.round(entry.contentRect.height / 10) * 10
        if (newHeight !== lastHeightRef.current) {
          lastHeightRef.current = newHeight
          saveHeightInSlate(newHeight)
        }
      }
    })

    resizeObserver.observe(container)
    return () => resizeObserver.disconnect()
  }, [saveHeightInSlate])

  return containerRef
}
